import React, { useMemo } from 'react';
import { Select } from '../../../../antd';
import { CLOUD_TYPES } from '../../../../../constants';
import { useGetActuatorInfoQuery } from '../../../../../api';

export const CloudTypeSelect = React.memo((props) => {
    const { isEditMode, selectedCloudType, handleCloudTypeChange } = props;
    const { data } = useGetActuatorInfoQuery();

    const options = useMemo(() => {
        const supportedCloudTypes = (data?.supported_clouds || []).map((sc) => sc.type);

        return CLOUD_TYPES.filter((ct) => supportedCloudTypes.includes(ct.value)).map((ct) => ({
            value: ct.value,
            label: ct.label,
        }));
    }, [data]);

    return (
        <Select
            value={selectedCloudType}
            onChange={handleCloudTypeChange}
            placeholder="Select Cloud type (required)"
            disabled={isEditMode}
            options={options}
        />
    );
});
